<template>
  <color-input
    :attribute="attribute"
    :errors="errors"
    :name="name"
    :readonly="readonly"
    :required="required"
    :label="label"
    :value="convertRgb2Hex(value)"
    @change="$emit('update:data', convertHex2Rgb($event.target.value))"
  ></color-input>
</template>

<script>
import ColorInput from "@kanrisha/components/Elements/Form/ColorInput";
export default {
  components: { ColorInput },
  props: {
    attribute: { type: String, default: null },
    errors: { type: Array, default: null },
    name: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    label: { type: String, default: '' },
    value: { type: String, default: '' },
  },
  emits: ['update:data'],
  setup() {
    const convertHex2Rgb = (hexString) => {
      return 'rgb('
        + parseInt(hexString.substring(1, 3), 16) + ', '
        + parseInt(hexString.substring(3, 5), 16) + ', '
        + parseInt(hexString.substring(5, 7), 16) + ')';
    };

    const convertRgb2Hex = (rgbString) => {
      let rgb = /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/i.exec(rgbString);

      return '#' + (1 << 24 | rgb[1] << 16 | rgb[2] << 8 | rgb[3]).toString(16).slice(1);
    };

    return {
      convertHex2Rgb,
      convertRgb2Hex,
    }
  },
};
</script>
